import { render, staticRenderFns } from "./ModalDetailCustomField.vue?vue&type=template&id=21e85477"
import script from "./ModalDetailCustomField.vue?vue&type=script&lang=js"
export * from "./ModalDetailCustomField.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailCustomField.vue?vue&type=style&index=0&id=21e85477&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e85477')) {
      api.createRecord('21e85477', component.options)
    } else {
      api.reload('21e85477', component.options)
    }
    module.hot.accept("./ModalDetailCustomField.vue?vue&type=template&id=21e85477", function () {
      api.rerender('21e85477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/customFields/components/ModalDetailCustomField.vue"
export default component.exports